import { environment } from '../../../environments/environment';

export const getConversationHistory = (botSessionId: string) => {
  const url = `${environment.conversationHistoryUrl}/${botSessionId}`;

  return fetch(url, { headers: { 'Content-Type': 'application/json' } }).then(data => data.json());
};
